import styled from 'styled-components';
import { IconButton, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import Popper from '@mui/material/Popper';

import colors from '../../../../../../../styles/colors';

const CloseButton = styled(IconButton)`
  position: absolute;
  top: -10px;
  right: -10px;
  background: ${colors.shades.beta2};
  z-index: 100;
  width: 32px;
  height: 32px;
  &:hover {
    background: ${colors.shades.beta1};
  }
`;

const StyledCloseIcon = styled(CloseIcon)`
  color: ${colors.base.alpha};
  font-size: 18px;
`;

const StyledPopper = styled(Popper)`
  border: 1px solid ${colors.shades.gamma3};
  margin: 100px 0 0 100px;
`;

const InstructionsContainer = styled.div`
  width: 600px;
  background: ${colors.shades.secondary5};
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  cursor: move;
`;

const InstructionsContent = styled.div`
  padding: 20px;
  overflow-y: auto;
  max-height: 400px;
`;

const Title = styled.h3`
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 600;
`;

const Text = styled(Typography)`
  font-size: 13px;
  white-space: pre-line;
`;

export {
  CloseButton,
  StyledCloseIcon,
  StyledPopper,
  InstructionsContainer,
  InstructionsContent,
  Title,
  Text,
};
